import React from 'react';
import { Text } from '@chakra-ui/react';

const ChapterHeading = ({ children }: { children: React.ReactNode }) => (
  <Text
    fontFamily="Lora"
    fontStyle="italic"
    fontWeight={600}
    fontSize={{ base: '26px', md: '30px' }}
    color="text.darkBlue"
    textAlign="center"
    lineHeight="1.25"
  >
    {children}
  </Text>
);

export default ChapterHeading;
